import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import  { ArticuloPage } from '../articulo/articulo';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-productos',
  templateUrl: 'productos.html',
})
export class ProductosPage {
  categoria;
  productos;
  accesorio = false;
  prodShow = true;
  diseno = false;
  diseShow = false;
  language = {};
  constructor(public navCtrl: NavController, public navParams: NavParams,public http: Http) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.categoria = this.navParams.get('categoria');
    console.log(this.categoria)
    if(this.categoria == 'AC'){
      this.accesorio = true;
      this.prodShow = false;
      this.diseno = false;
      this.diseShow = false;
    }else if(this.categoria == 'DS'){
      this.accesorio = false;
      this.prodShow = false;
      this.diseno = true;
      this.diseShow = false;
    }else{
      this.accesorio = false;
      this.prodShow = true;
      this.diseno = false;
      this.diseShow = false;
      this.http.get("https://ebenlovequickpc.com/API/producto.php?cl=select&cat="+this.categoria).subscribe((data)=>{
     this.productos = data.json(); 
     });
    }
    

  
  }
  articulo(prod){
    this.navCtrl.setRoot(ArticuloPage,{prod:prod});
  }

  ionViewDidLoad() {
  }

  subdis(sub){
    console.log(sub)
    this.accesorio = false;
    this.prodShow = false;
    this.diseno = false;
    this.diseShow = true;
    this.http.get("https://ebenlovequickpc.com/API/producto.php?cl=selectCatDis&subcat="+sub).subscribe((data)=>{
      this.productos = data.json();
      console.log(data.json())
    });
  }

  subcat(sub){
    this.http.get("https://ebenlovequickpc.com/API/producto.php?cl=selectCat&cat="+this.categoria+"&subcat="+sub).subscribe((data)=>{
     this.productos = data.json();
  });
    this.accesorio = false;
    this.prodShow = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/productos/productos.ts